/**
 * Le code d'un choix lu dans un QR code. Ceux du livre menent a `https://<domaine>/c/<code>` ;
 * un code ecrit tel quel est accepte aussi. Le domaine n'est pas verifie : c'est le code qui
 * dit s'il vient du livre, et le moteur le refuse sinon. `null` : ce QR code n'est pas un choix.
 */
export function extraireCode(contenu: string): string | null {
  const texte = contenu.trim();
  const adresse = /^https?:\/\/[^/\s]+\/c\/([A-Za-z0-9-]{1,12})\/?(?:[?#]\S*)?$/.exec(texte);
  if (adresse) return adresse[1] ?? null;
  if (/^[A-Za-z0-9][A-Za-z0-9 -]{1,8}$/.test(texte)) return texte;
  return null;
}
